import { makeLoadingMessage } from "utils/makeLoadingMessage";

export const withLoadingMessage = async <T>(cb: () => Promise<T>): Promise<T> => {
  const hide = makeLoadingMessage();
  try {
    return await cb();
  } catch (error) {
    throw error;
  } finally {
    hide();
  }
};
